import React, { useState, useContext, useEffect } from "react";
import Fade from "react-reveal/Fade";
import "../../components/LandingPage/landingpage.css";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import Logo from "../../components/assets/logo.png";
import Phone from "../../components/assets/phone.svg";
import Calculator from "../../components/HomeCalculation";
import Banner from "../../components/assets/banner.png";
import CowBoy from "../../components/assets/face.png";
import { useSnackbar } from "notistack";
import axios from "axios";
import { UserContext } from "../../components/UserContext";
import Cookies from "js-cookie";
import BTCRate from "../../components/BTCRate";

const url = "https://www.bitmasta.io/php/functioned.php";
function Register(props) {
  const user = useContext(UserContext);
  const [details, setDetails] = useState({
    firstname: "",
    email: "",
    phone: "",
    password: "",
    code: "",
  });
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (props.match.params.email)
      setDetails((prev) => ({ ...prev, email: props.match.params.email }));
    if (props.match.params.ref)
    setDetails((prev) => ({ ...prev, code: props.match.params.ref }));
  }, [props.match.params]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { firstname, email, phone, password,code } = details;
    if (!firstname || !email || !phone || !password) {
      enqueueSnackbar("All fields are required", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    } else {
      let formData = new FormData();
      formData.append("Register_Name", firstname);
      formData.append("Register_Email", email);
      formData.append("Register_Pass", password);
      formData.append("Register_Phone", phone);
      formData.append("Referral_code", code);
      axios.post(url, formData).then((res) => {
        if (res.data.status === "Account Exists")
          enqueueSnackbar(res.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        else if (res.data.status === "Connection Error")
          enqueueSnackbar(res.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        else if (res.data.status === "Registered Successfully") {
          enqueueSnackbar(res.data.message, {
            variant: "success",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
          Cookies.set("auth", res.data.Email, { expires: 1 });
          if (Cookies.get("auth")) user.setUser(Cookies.get("auth"));
          props.history.push("/dashboard");
        }
      });
    }
  };
  return (
    <div className="bts-landing-page-wrapper">
      <Navbar className="navbg d-md-none" expand="lg" fixed="top">
        <Navbar.Brand href="/">
          <img src={Logo} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="/exchange" className="nav-items">
              Rates
            </Nav.Link>
            <Nav.Link href="/login" className="nav-items">
              Login
            </Nav.Link>
            <Nav.Link href="/register" className="nav-items">
              Register
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <div className="bts-landing-page-caption-section">
        <div className="bts-landing-left-menu">
          <div className="bts-landing-page-caption-logo">
            <Link to="/">
              <img src={Logo} alt="" />
            </Link>
          </div>
          <div className="bts-landing-page-caption-links align-self-center d-flex justify-content-end">
            <Link to="/exchange" className="notactive">
              Rates
            </Link>
            <Link to="/login" className="notactive">
              Login
            </Link>
            <Link to="/" className="active">
              Register
            </Link>
          </div>
        </div>
        <Fade bottom delay={1000}>
          <div className="text-center push-top whiteText b7 mediumText">
            We love that
            <br />
            you chose us &nbsp;
            <img src={CowBoy} alt="" />
          </div>
        </Fade>
        <Fade bottom delay={1200}>
          <p className="whiteText text-center pt-2 b3 medText">
            Please fill this up, so we can start!
          </p>
        </Fade>
        <Fade bottom delay={1500}>
          <div className="pt text-center">
            <form action="post">
              <div>
                <input
                  type="text"
                  value={details.firstname}
                  onChange={(e) =>
                    setDetails({ ...details, firstname: e.target.value })
                  }
                  placeholder="Firstname"
                  id="firstnameInput"
                  className="mt-3 emailInput"
                />
              </div>
              <div>
                <input
                  type="email"
                  value={details.email}
                  onChange={(e) =>
                    setDetails({ ...details, email: e.target.value })
                  }
                  placeholder="Email"
                  id="emailInputs"
                  className="mt-3 emailInput"
                />
              </div>
              <div>
                <input
                  type="text"
                  value={details.code}
                  onChange={(e) =>
                    setDetails({ ...details, code: e.target.value })
                  }
                  placeholder="Referral code (optional)"
                  id="codeInput"
                  className="mt-3 emailInput"
                />
              </div>
              <div>
                <input
                  type="number"
                  value={details.phone}
                  onChange={(e) =>
                    setDetails({ ...details, phone: e.target.value })
                  }
                  placeholder="Phone Number"
                  id="numberInput"
                  className="mt-3 emailInput"
                />
              </div>
              <div>
                <input
                  type="password"
                  value={details.password}
                  onChange={(e) =>
                    setDetails({ ...details, password: e.target.value })
                  }
                  placeholder="Password"
                  id="passwordInput pppppp"
                  className="mt-3 emailInput"
                />
              </div>
              <div>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="submitButton mt-2"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </Fade>
        <Fade delay={1600}>
          <div className="text-center">
            <div className=" b5 medText push">
              <Link to="/exchange" className="whiteText guest">
                I'm a Guest
              </Link>
            </div>
            <div className="mt-2">
              <Link to="/login" className="bts-caption">
                Login
              </Link>
            </div>
          </div>
        </Fade>
      </div>
      <div className="bts-landing-page-testimonials">
        <div className="d-flex justify-content-between nav-align">
          <div className="ts-landing-page-right-menu align-self-center">
            <BTCRate />
          </div>
          <div className="ts-landing-page-right-menu align-self-center">
            <Link to="tel:+2348162898892" className="blueText b7 medText plain">
              <img src={Phone} alt="" className="pr-3" /> Contact Us
            </Link>
          </div>
        </div>
        <div className="push-top">
          <>
              <Fade bottom delay={1200}>
                  <Calculator />
              </Fade>
            </>
          <div className="push-down">
            <img src={Banner} alt="" />
            <p className="pt-2">Supported payment methods</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
